/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.AboutPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'PARAMETA Solutions',
  },
  aboutDescription: {
    id: `${scope}.aboutDescription`,
    defaultMessage: `PARAMETA Solutions Data & Analytics supply pricing, reference data and analytical tools for various asset classes and markets. Our products facilitate trading, enhance transparency, reduce risk and improve operational efficiency. We support our clients ability to make decisions in investment, portfolio analysis, valuation, risk, regulation and compliance. We pride ourselves on our rigorous quality assurance processes, which ensure the integrity and robustness of our products.`,
  },
  aboutCall: {
    id: `${scope}.aboutCall`,
    defaultMessage: `Contact us on {contactLink} to talk about your data solutions.`,
  },
  contactEmail: {
    id: `${scope}.contactEmail`,
    defaultMessage: 'findoutmore@tpicap.com',
  },
});
